import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideClientHydration, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AppRoutingModule } from './app-routing.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { JwtInterceptor } from './core/interceptor/jwt.interceptor';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(SweetAlert2Module.forRoot(), BrowserModule, BrowserAnimationsModule, AppRoutingModule, ClickOutsideModule, LoadingBarRouterModule, 
        // core & shared
        CoreModule, SharedModule),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideTranslateService({
            lang: 'es-MX',
            fallbackLang: 'es-MX'
        }),
        provideTranslateHttpLoader({
            prefix: 'assets/i18n/',
            suffix: '.json'
        }),
        provideHttpClient(withInterceptorsFromDi()),
        provideClientHydration()
    ]
};
